import axios from "axios"

export const getTokenByTicktAndCliant = async (tikite: any, cliantId: any) => {
  return await axios.post(`${process.env.REACT_APP_AUTHPATH}/exchangeToken`, {
    ticket: tikite,
    clientId: cliantId ? cliantId : '6445e261-45e8-4e33-8f8c-2cf6b0c783a5'
  })
}